module.exports = __webpack_public_path__ + "static/img/6.57696ab.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/3/sp/6.png
// module id = oei7
// module chunks = 0